import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import LocaleSwitcher from "../common/components/LocaleSwitcher";
import PersonIcon from "../assets/icons/PersonIcon";
import WrokIcon from "../assets/icons/WrokIcon";
import DepartmentIcon from "../assets/icons/DepartmentIcon";
import CompanyIcon from "../assets/icons/CompanyIcon";
import LocationIcon from "../assets/icons/LocationIcon";
import { Urls } from "../constant/urls";

const PainterRegistration = () => {
  const [state, setState] = React.useState({
    checkedA: true,
  });
  const [pageData, setPageData] = useState([]);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (i18n.language === "en" || i18n.language === undefined) {
      setState({ checkedA: false });
    } else {
      setState({ checkedA: true });
    }
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    location: "",
  });

  const [error, setError] = useState({
    name: "",
    location: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const onSubmitHandler = (e) => {
    e.preventDefault();
    let newError = { ...error };

    if (formData.name === "") {
      newError = {
        ...newError,
        name: "Enter name...",
      };
    } else {
      newError = {
        ...newError,
        name: "", // Clear the error message if name is not empty
      };
    }

    setError(newError);

    if (formData.name !== "") {
      navigate("/painter-card-preview", { state: formData });
    }
  };

  const localeHandler = (checked) => {
    if (checked) {
      i18n.changeLanguage("bn");
    } else {
      i18n.changeLanguage("en");
    }
  };

  useEffect(() => {
    fetchPageData();
  }, []);

  const fetchPageData = async () => {
    try {
      const response = await fetch(Urls.painterPage);

      if (response.ok) {
        const data = await response.json();
        if (data.status === 200) {
          setPageData(data.data);
        } else {
          console.error("API response status is not success:", data.error);
        }
      } else {
      }
    } catch (error) {
      console.error("Error fetching occasions:", error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setLoader(false);
    }, 300);
  }, []);

  return (
    <>
      <div className="w-full min-h-screen relative flex justify-center items-center flex-col px-4 md:py-10 py-5">
        <div className="flex-grow flex flex-col items-center justify-center">
          <img
            className="hidden md:block absolute top-0 left-0 w-full h-full object-cover object-top -z-10"
            src={pageData.banner}
            alt=""
          />
          <img
            className="md:hidden absolute top-0 left-0 w-full h-full object-cover object-top -z-10"
            src={pageData.thumb}
            alt=""
          />

          <img
            className="brand_logo w-[70px] md:w-[100px] xl:w-[143px] 2xl:w-[170px] xl:mb-10 mb-7"
            src={
              i18n.language === "en" || i18n.language === undefined
                ? `/berger-logo.png`
                : `/berger-logo-bn.png`
            }
            alt=""
          />
          <div className="w-full sm:max-w-[718px] mx-auto">
            <div className="flex sm:flex-row flex-col justify-between items-center w-full gap-2 xl:mb-8 mb-5">
              <h1 className="2xl:text-2xl xl:text-[22px] text-xl font-bold sm:text-left text-center">
                {t("infoTitle")}
              </h1>
              <div className="locale-wrapper">
                <LocaleSwitcher
                  state={state}
                  setState={setState}
                  localeHandler={localeHandler}
                />
              </div>
            </div>

            {loader ? (
              <div className="relative w-full h-[100px]">
                <svg className="spinner" viewBox="0 0 50 50">
                  <circle
                    className="path"
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    strokeWidth="5"
                  ></circle>
                </svg>
              </div>
            ) : (
              <div className="relative   bg-white border border-gray-100 rounded-lg  z-50 p-4">
                <div className=" w-full h-full ">
                  <form className="space-y-3" onSubmit={onSubmitHandler}>
                    <div className="flex gap-4 flex-wrap">
                      <div className="w-full">
                        <label
                          htmlFor="name"
                          className="block mb-2 text-sm text-[#002736]"
                        >
                          {t("name")}
                          <span className="text-[#00ADEE]">*</span>
                        </label>
                        <div className="relative">
                          <input
                            type="text"
                            name="name"
                            id="name"
                            value={formData.name}
                            onChange={handleChange}
                            className={`icon-input ${
                              formData.name !== "" ? "active" : ""
                            } bg-[#F0F0F0] border-[2px] border-transparent font-medium text-[#212121] text-sm rounded-[65px] focus:border-[#00ADEE] block w-full px-4 pl-[47px] py-[10px] focus:outline-none`}
                            placeholder={t("enterName")}
                            autoComplete="off"
                          />
                          <span className="absolute left-[18px] top-1/2 -translate-y-1/2">
                            <PersonIcon />
                          </span>
                        </div>
                        {error.name && (
                          <p className="text-sm text-[#f12222d3] font-medium pl-2 mt-1">
                            {error.name}
                          </p>
                        )}
                      </div>
                      <div className="w-full">
                        <label
                          htmlFor="location"
                          className="block mb-2 text-sm text-[#002736]"
                        >
                          {t("location")}:
                        </label>
                        <div className="relative">
                          <input
                            type="text"
                            name="location"
                            id="location"
                            value={formData.location || ""}
                            onChange={handleChange}
                            className={`icon-input ${
                              formData.location !== "" ? "active" : ""
                            } bg-[#F0F0F0] border-[2px] border-transparent font-medium text-[#212121] text-sm rounded-[65px] focus:border-[#00ADEE] block w-full px-4 pl-[47px] py-[10px] focus:outline-none`}
                            placeholder={t("enterLocation")}
                            autoComplete="off"
                          />
                          <span className="absolute left-[18px] top-1/2 -translate-y-1/2">
                            <LocationIcon />
                          </span>
                        </div>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="w-full text-white h-[50px] bg-[#00ADEE] hover:bg-[#00aeeec5] font-medium rounded-full text-sm px-5 py-2.5 text-center"
                      onSubmit={onSubmitHandler}
                    >
                      {t("generateCard")}
                    </button>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="md:pt-10 pt-5 text-center text-sm">
          <span className="text-white">©</span>
          2025 Berger Paints Bangladesh Limited. All Rights Reserved.
        </div>
      </div>
    </>
  );
};

export default PainterRegistration;
